module.exports = __webpack_public_path__ + "mobile/img/img_salon_article.09bf5a7f.png";